<app-header></app-header>

<!-- Page Header Start -->
<div class="container-fluid page-header py-5">
    <div class="container text-center pd-t-120 pd-b-120">
        <h1 class="display-5 text-white mb-4">Contact Us</h1>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
                <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
                <li class="breadcrumb-item"><a routerLink="/">Pages</a></li>
                <li class="breadcrumb-item" aria-current="page">Contact Us</li>
            </ol>
        </nav>
    </div>
</div>
<!-- Page Header End -->

<!-- Fact Start -->
<div class="container-fluid bg-color-secondary py-5">
  <div class="container">
    <div class="row">
      
      <!-- Loop over facts array using *ngFor -->
      <div *ngFor="let fact of facts" class="col-lg-3">
        <div class="d-flex counter">
          <h1 class="me-3 color-dark counter-value">{{ fact.value }}</h1>
          <h5 class="text-white mt-1">{{ fact.label }}</h5>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- Fact End -->

<!-- Contact Start -->
<div class="container-fluid py-5 mb-5">
  <div class="container">
    <div class="text-center mx-auto pb-5 wow fadeIn" data-wow-delay=".3s" style="max-width: 600px;">
      <h5 class="color-primary">Get In Touch</h5>
      <h1 class="mb-3">Contact Us</h1>
    </div>

    <div class="contact-detail position-relative p-5">
      
      <!-- Contact Info Cards Loop -->
      <div class="row g-5 mb-5 justify-content-center">
        <div *ngFor="let item of contactDetails" class="col-xl-4 col-lg-6">
          
          <div class="d-flex bg-light p-3 rounded">
            <div class="flex-shrink-0 btn-square bg-color-secondary rounded-circle" style="width: 64px; height: 64px;">
              <i [class]="item.icon + ' text-white'"></i>
            </div>
            <div class="ms-3">
              <h6 class="color-dark">{{ item.title }}</h6>
              <a [href]="item.link" class="h6" target="_blank">{{ item.value }}</a>
            </div>
          </div>

        </div>
      </div>

      <!-- Map & Form Row -->
      <div class="row g-5">
        
        <!-- Google Map iframe -->
        <div class="col-lg-6 wow fadeIn" data-wow-delay=".3s">
          <div class="p-5 h-100 rounded contact-map">
            <iframe 
              class="rounded w-100 h-100" 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3025.4710403339755!2d-73.82241512404069!3d40.685622471397615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c26749046ee14f%3A0xea672968476d962c!2s123rd%20St%2C%20Queens%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1686493221834!5m2!1sen!2sbd" 
              style="border:0;" 
              allowfullscreen="" 
              loading="lazy" 
              referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>

        <!-- Contact Form (Reactive Form) -->
        <div class="col-lg-6 wow fadeIn" data-wow-delay=".5s">
          <div class="p-5 rounded contact-form">
            <form (submit)="sendEmail($event)" #contactForm="ngForm">
              
              <div class="row gx-3 gy-0">
                
                <!-- Name Field -->
                <div class="col-12">
                  <div class="form-group mb-3">
                      <label class="visually-hidden" for="user_name">Name</label>
                      <input class="form-control" type="text" minlength="2" maxlength="15"
                          [class.is-invalid]="userName.invalid && userName.touched" name="user_name" id="name"
                          placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                      <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mrb-10">
                          Name is required.
                      </div>
                  </div>
                </div>

                <!-- Email Field -->
                <div class="col-12">
                  <div class="form-group mb-3">
                      <label class="visually-hidden" for="user_email">Email</label>
                      <input class="form-control" type="email" minlength="2" maxlength="35"
                          [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email"
                          id="email" placeholder="Email *" [(ngModel)]="formData.user_email" #userEmail="ngModel" required
                          email>
                      <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mrb-10">
                          A valid email is required.
                      </div>
                  </div>
                </div>

              </div>

              <!-- Message Field -->
              <div class="form-group mb-3">
                  <label class="visually-hidden" for="message">Project Details</label>
                  <textarea class="form-control" name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched"
                      id="message" rows="7" placeholder="Project Details" [(ngModel)]="formData.message"
                      #userMessage="ngModel" required></textarea>
                  <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                      Project details are required.
                  </div>
              </div>

              <div class="text-right">
                  <button type="submit" name="submit" class="btn btn-dark text-white py-3 px-5 mt-3"
                      [disabled]="contactForm.invalid" value="Send Mail">Send Mail</button>
              </div>
              
            </form>
            <div class="messages mrt-20 text-center"></div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
<!-- Contact End -->